
import React from "react";
import TagButton from "../common/TagButton";

const team ="https://storage.googleapis.com/think41-web-new/assets/About/team.png";

  
export default function TeamSection() {
  return (
    <div
      className="flex flex-col items-center w-full max-w-[1440px] px-4 sm:px-8 md:px-[120px] pt-0 mx-auto"
      style={{
        background:
          "radial-gradient(69.26% 88.65% at 51.5% 25.79%, #FCFCFC 0%, rgba(252, 252, 252, 0.00) 100%)",
      }}
    >
      <div className="flex flex-col">
        {/* Tag Button */}
        <div className="self-start mb-4">
          <TagButton text="Who We Are" />
        </div>

        {/* Heading */}
        <h2 className="text-[36px] font-[600] leading-[133.1%] font-montserrat bg-gradient-to-r from-black to-[#0060C7] bg-clip-text text-transparent self-start mb-6">
          About Us
        </h2>

        {/* Section with text and image */}
        <section className="flex flex-col-reverse xl:flex-row items-center xl:items-start w-full gap-8 mb-[15px]">
          {/* Text */}
          <div className="flex flex-col gap-[16px] text-left w-full xl:w-1/2">
            <p className="text-[#000] text-justify font-roboto text-[16px] font-[300] leading-[22.4px]">
              We’re a <strong>Full-Stack Generative AI company</strong> — young
              in structure, but grounded in decades of enterprise technology
              experience. Our team has built large-scale systems and AI products
              for global enterprises, and we’re now applying that expertise to
              create intelligent platforms that bring humans and AI closer
              together. Our products are built to enhance how people work not by
              replacing them, but by enabling smarter decisions, faster
              execution, and more meaningful collaboration. We design systems
              that embed intelligence across the stack — from user interfaces to
              backend workflows — so AI becomes a natural part of daily
              operations.
            </p>

            <p className="text-[#000] text-justify font-roboto text-[16px] font-[300] leading-[22.4px]">
              With a strong tech foundation and a human-first mindset, we’re
              moving AI from labs to live environments. We help organizations
              work with AI as an ally, not an add-on — driving impact that’s
              measurable, scalable, and built to last.
            </p>
          </div>

          {/* Image */}
          <div className="w-full xl:w-1/2 h-[290px] flex-shrink-0">
            <img
              src={team}
              alt="team"
              className="w-full h-full object-cover rounded-md"
            />
          </div>
        </section>
      </div>
    </div>
  );
}
